<template>
    <div class="ui-control" :class="{ 'ui-control--block': block }">
        <span v-if="label" class="ui-control__label">{{ label }}</span>
        <div
            class="ui-control__shell"
            :class="{
                'is-focused': isFocused,
                'is-disabled': disabled,
                'is-error': props.error === true || !!errorMessage,
            }"
        >
            <slot name="prefix" />
            <input
                :id="id"
                ref="inputRef"
                class="ui-control__input"
                :type="type"
                :value="modelValue"
                :placeholder="placeholder"
                :disabled="disabled"
                :required="required"
                :name="name"
                :autocomplete="autocomplete"
                :min="min"
                :max="max"
                :step="step"
                :inputmode="inputmode"
                :aria-label="label || undefined"
                v-bind="$attrs"
                @input="onInput"
                @focus="isFocused = true"
                @blur="onBlur"
                @change="$emit('change', $event)"
            />
            <slot name="suffix" />
        </div>
        <div v-if="errorMessage" class="ui-control__error">
            <p>{{ errorMessage }}</p>
        </div>
    </div>
</template>

<script setup>
import { computed, ref } from 'vue';

defineOptions({ inheritAttrs: false });

const props = defineProps({
    modelValue: { type: [String, Number], default: '' },
    modelModifiers: { type: Object, default: () => ({}) },
    type: { type: String, default: 'text' },
    label: { type: String, default: '' },
    placeholder: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
    required: { type: Boolean, default: false },
    block: { type: Boolean, default: true },
    id: { type: String, default: undefined },
    name: { type: String, default: undefined },
    autocomplete: { type: String, default: undefined },
    min: { type: [String, Number], default: undefined },
    max: { type: [String, Number], default: undefined },
    step: { type: [String, Number], default: undefined },
    inputmode: { type: String, default: undefined },
    error: { type: [String, Array, Boolean], default: '' },
});

const emit = defineEmits(['update:modelValue', 'blur', 'change', 'focus']);

const inputRef = ref(null);
const isFocused = ref(false);

const errorMessage = computed(() => {
    if (props.error === true) {
        return '';
    }
    if (Array.isArray(props.error)) {
        return props.error[0] || '';
    }
    return props.error || '';
});

function onInput(event) {
    const { value } = event.target;
    emit('update:modelValue', props.modelModifiers.number && value !== '' ? Number(value) : value);
}

function onBlur(event) {
    isFocused.value = false;
    emit('blur', event);
}

defineExpose({ inputRef, focus: () => inputRef.value?.focus() });
</script>
